module.exports = __webpack_public_path__ + "static/img/M2SSDB-B0sdhH5t.af3756c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/M2SSDB-B0sdhH5t.png
// module id = DEQE
// module chunks = 16